package ru.villawonka.app.domain.model

data class UserCountryDomain(
    val country: CountryDomain,
    val cities: List<CityInfoDomain>,
    val accommodationTypes: List<AccommodationTypeDomain>,
    val accommodationAdditions: List<AccommodationAdditionDomain>,
)